import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import useFormValidator from 'useFormValidator';
import DateInputPicker from 'modules/common/components/DateInputPicker2';
import PropTypes from 'prop-types';
import moment from 'moment';
import { ModalContext } from 'App';
import * as c from '../constant';
import * as actions from '../action';

function UpdateModal({
  updateTaxAmnesty,
  getTaxAmnestyList,
  updateList,
  id,
  history,
  getSingleTaxAmnesty,
  updating,
}) {
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    ordinance: '',
    effectivity_start: '',
    effectivity_end: ''
  });

  const validateForm = useFormValidator(formData, {
    name: 'required',
    ordinance: 'required',
    effectivity_start: 'required|date',
    effectivity_end: 'required|date'
  });

  const setModal = useContext(ModalContext);

  const handleOnSubmit = e => {
    e.preventDefault();

    const args = {
      ...formData,
      effectivity_start: moment(_.get(formData, 'effectivity_start')).format('MM-DD-YYYY'),
      effectivity_end: moment(_.get(formData, 'effectivity_end')).format('MM-DD-YYYY'),
    };

    updateTaxAmnesty(id, args, ({ data }) => {
      setModal({ isOpen: false });
      getTaxAmnestyList();
      getSingleTaxAmnesty(id);
      history.push(`/bpls/settings/tax-amnesty/${_.get(data, 'id')}`);
    });
  };

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onSetFormData = () => {
    if (!_.isEmpty(updateList)) {
      const args = {
        ...updateList,
      };
      setFormData(_.pick(args, _.keys(c.FORM_DATA)));
    }
  };

  useEffect(() => {
    onSetFormData();
  }, []);

  const onChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const onChangeDate = key => ({ target: { value } }) => {
    setFormData({
      ...formData,
      [key]: value,
    });
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label className="full-label mb-0">
              Name:
              {validateForm.renderMessage('name')}
            </label>
            <input
              className="form-control"
              type="text"
              name="name"
              onChange={onChange}
              value={_.get(formData, 'name')}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Description:
            </label>
            <input
              className="form-control"
              type="text"
              name="description"
              onChange={onChange}
              value={_.get(formData, 'description')}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Ordinance:
              {validateForm.renderMessage('ordinance')}
            </label>
            <input
              className="form-control"
              type="text"
              name="ordinance"
              onChange={onChange}
              value={_.get(formData, 'ordinance')}
            />
          </div>
          <div className="col-6 form-group">
            <label className="full-label mb-0">
              Effectivity Start:
              {validateForm.renderMessage('effectivity_start')}
            </label>
            <DateInputPicker
              className="form-control"
              dateFormat="MM/DD/YYYY"
              onChange={onChangeDate('effectivity_start')}
              value={_.get(formData, 'effectivity_start')}
            />
          </div>
          <div className="col-6 form-group">
            <label className="full-label mb-0">
              Effectivity End:
              {validateForm.renderMessage('effectivity_end')}
            </label>
            <DateInputPicker
              className="form-control"
              dateFormat="MM/DD/YYYY"
              onChange={onChangeDate('effectivity_end')}
              value={_.get(formData, 'effectivity_end')}
              minDate={new Date(_.get(formData, 'effectivity_start'))}
            />
          </div>
        </div>

        <div className="d-flex justify-content-center">
          <button
            disabled={updating || !validateForm.response.is_passed}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>{' '}
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

UpdateModal.propTypes = {
  updateList: PropTypes.instanceOf(Object).isRequired,
  updateTaxAmnesty: PropTypes.instanceOf(Function).isRequired,
  getTaxAmnestyList: PropTypes.instanceOf(Function).isRequired,
  id: PropTypes.string.isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getSingleTaxAmnesty: PropTypes.instanceOf(Function).isRequired,
  updating: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  updating: api.loading.indexOf(c.UPDATE_TAX_AMNESTY) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(UpdateModal);
